import victorUrl from '@assets/images/victor.jpg'
import alizeeUrl from '@assets/images/alizee.jpg'
import gwenUrl from '@assets/images/gwen.jpg'
import julieUrl from '@assets/images/julie.jpg'
import dariusUrl from '@assets/images/darius.jpg'
import pierreUrl from '@assets/images/pierre.jpg'
import arthurUrl from '@assets/images/arthur.jpg'
import alexisUrl from '@assets/images/alexis.jpg'

import benoit1 from '@assets/images/benoit/benoit1.jpg'
import benoit2 from '@assets/images/benoit/benoit2.jpg'
import benoit3 from '@assets/images/benoit/benoit3.jpg'
import benoit4 from '@assets/images/benoit/benoit4.jpg'
import benoit5 from '@assets/images/benoit/benoit5.jpg'
import benoit6 from '@assets/images/benoit/benoit6.jpg'

import benoit7 from '@assets/images/benoit/benoit7.jpg'
import benoit8 from '@assets/images/benoit/benoit8.jpg'
import benoit9 from '@assets/images/benoit/benoit9.jpg'
import benoit10 from '@assets/images/benoit/bena.jpg'
import benoit11 from '@assets/images/benoit/benoit11.jpg'
import benoit12 from '@assets/images/benoit/beka.jpg'

import benoit13 from '@assets/images/benoit/benoit13.jpg'
import benoit14 from '@assets/images/benoit/benoit14.jpg'
import benoit15 from '@assets/images/benoit/vrai-benoit.jpg'
import benoit16 from '@assets/images/benoit/benoit16.jpg'
import benoit17 from '@assets/images/benoit/benoit17.jpg'
import benoit18 from '@assets/images/benoit/benoit18.jpg'

import benoit19 from '@assets/images/benoit/benoit19.jpg'
import benoit20 from '@assets/images/benoit/benoit20.jpg'
import benoit21 from '@assets/images/benoit/benoit21.jpg'
import benoit22 from '@assets/images/benoit/benoit22.jpg'
import benoit23 from '@assets/images/benoit/benoit23.jpg'
import benoit24 from '@assets/images/benoit/benoit24.jpg'

import benoit25 from '@assets/images/benoit/benoit25.jpg'
import benoit26 from '@assets/images/benoit/benoit26.jpg'
import benoit27 from '@assets/images/benoit/benoit27.jpg'
import benoit28 from '@assets/images/benoit/benoit28.jpg'
import benoit29 from '@assets/images/benoit/benoit10.jpg'
import benoit30 from '@assets/images/benoit/benoit12.jpg'

// import benoit31 from '@assets/images/benoit/benoit31.jpg'
// import benoit32 from '@assets/images/benoit/benoit32.jpg'
// import benoit33 from '@assets/images/benoit/benoit33.jpg'
// import benoit34 from '@assets/images/benoit/benoit34.jpg'
// import benoit35 from '@assets/images/benoit/benoit35.jpg'
// import benoit36 from '@assets/images/benoit/benoit36.jpg'
// import benoit37 from '@assets/images/benoit/benoit37.jpg'
// import benoit38 from '@assets/images/benoit/benoit38.jpg'
// import benoit39 from '@assets/images/benoit/benoit39.jpg'
// import benoit40 from '@assets/images/benoit/benoit40.jpg'


export default [{
  name: 'Victor',
  image: victorUrl,
  emoji: '🍆',
}, {
  name: 'Alizée',
  image: alizeeUrl,
  emoji: '🍑',
}, {
  name: 'Gwen',
  image: gwenUrl,
  emoji: '🍆',
}, {
  name: 'Julie',
  image: julieUrl,
  emoji: '🍑',
}, {
  name: 'Darius',
  image: dariusUrl,
  emoji: '🍆',
}, {
  name: 'Pierre',
  image: pierreUrl,
  emoji: '🍆',
}, {
  name: 'Arthur',
  image: arthurUrl,
  emoji: '🍆',
}, {
  name: 'Alexis',
  image: alexisUrl,
  emoji: '🍆',
}, 

{
  name: 'Benoit', 
  image: benoit1,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit2,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit3,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit4,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit5,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit6,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit7,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit8,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit9,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit10,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit11,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit12,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit13,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit14,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit15,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit16,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit17,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit18,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit19,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit20,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit21,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit22,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit23,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit24,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit25,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit26,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit27,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit28,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit29,
  emoji: '🍆'
}, {
  name: 'Benoit', 
  image: benoit30,
  emoji: '🍆'
}]